/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CustomerInvoiceState {
  Unpaid = "unpaid",
  PaymentSent = "payment_sent",
  PaymentReceived = "payment_received",
  Reconciled = "reconciled",
  BadDebt = "bad_debt",
  Voided = "voided",
  Deleted = "deleted",
}

export function instanceOfCustomerInvoiceState(value: any): boolean {
  for (const key in CustomerInvoiceState) {
    if (Object.prototype.hasOwnProperty.call(CustomerInvoiceState, key)) {
      if (
        CustomerInvoiceState[key as keyof typeof CustomerInvoiceState] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomerInvoiceStateFromJSON(json: any): CustomerInvoiceState {
  return CustomerInvoiceStateFromJSONTyped(json, false);
}

export function CustomerInvoiceStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerInvoiceState {
  return json as CustomerInvoiceState;
}

export function CustomerInvoiceStateToJSON(
  value?: CustomerInvoiceState | null,
): any {
  return value as any;
}

export function CustomerInvoiceStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CustomerInvoiceState {
  return value as CustomerInvoiceState;
}
